import api from '@/helpers/api'

const API_READ = `/api/tier/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ
const API_CHECK = `${API_READ}check`
const API_READ_PROFILE = `${API_READ}profile/`
const API_READ_MEMBER = `/api/member-tier/`
const API_READ_DELETE = API_READ_MEMBER
const API_READ_ALL = `/api/tier/read_all/`

export default {
    namespaced: true,
    state: {
        status: '',
        MemberTier: [],
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {},
        allTiers: []
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        read(state, { MemberTier }) {
            state.MemberTier = [...MemberTier]
        },
        error(state) {
            state.status = 'error'
        },
        success(state) {
            state.status = 'success'
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = filter;
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        clear_search(state) {
            state.search = {};
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        },
        set_all_tiers(state, { allTiers }) {
            state.allTiers = allTiers;
        }
    },
    actions: {
        check({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', API_CHECK, {}, data)
                    .then((response) => {
                        commit('success');
                        return resolve(response)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read({ commit, state }) {
            commit('request');
            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search })
                    .then((result) => {
                        commit('success')
                        commit('read', { MemberTier: result.data.data })
                        commit('switch_page', { meta: { ...result.data.meta } })
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err);
                    });
            });
        },
        read_member({ commit, state }, id) {
            commit('request');
            const { meta } = state
            const { filter } = state
            const { search } = state
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_MEMBER}${id}`, { meta, filter, search })
                    .then((result) => {
                        commit('read', { MemberTier: result.data.data });
                        commit('switch_page', { meta: { ...result.data.meta } });
                        commit('success');
                        return resolve(result);
                    })
                    .catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        create_member({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_READ_MEMBER, {}, data)
                    .then((response) => {
                        commit('success');
                        return resolve(response)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        update_member({ commit }, { data }) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('put', `${API_READ_MEMBER}${data.member_id}`, {}, data)
                    .then((result) => {
                        commit('read', { MemberTier: result.data.data });
                        commit('switch_page', { meta: { ...result.data.meta } });
                        commit('success');
                        return resolve(result);
                    })
                    .catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        read_profile({ commit }, id) {

            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_PROFILE}${id}`)
                    .then((result) => {
                        commit('success')
                        commit('read', { MemberTier: result.data.data })
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        read_single({ commit }, id) {

            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        delete({ commit, dispatch, state }, id) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.MemberTier.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success');
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('err', { message: err });
                        return reject(err.response.data)
                    });
            })
        },
        delete_member({ commit, dispatch, state }, id) {

            commit('request');

            // Check if this is the last item on current page (before delete)
            const itemsCount = state.MemberTier.length;
            const currentPage = state.meta.page;
            const willBeEmpty = itemsCount === 1 && currentPage > 1;

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_READ_DELETE}${id}`)
                    .then((response) => {
                        // If page will be empty after delete, navigate to previous page first
                        if (willBeEmpty) {
                            const newMeta = { ...state.meta, page: currentPage - 1 };
                            commit('switch_page', { meta: newMeta });
                        }

                        // Reload data
                        dispatch('read');
                        commit('success');
                        return resolve(response.data)
                    }).catch((err) => {
                        commit('err', { message: err });
                        return reject(err.response.data)
                    });
            })
        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        create({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then((response) => {
                        commit('success');
                        return resolve(response)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        read_all({ commit }, id) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ_ALL}${id}`)
                    .then((result) => {
                        commit('success');
                        commit('set_all_tiers', { allTiers: result.data.data });
                        return resolve(result)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        }
    },
    getters: {
        MemberTier: () => state => state.MemberTier,
        allTiers: () => state => state.allTiers
    }
}